define((require) => {
    "use strict";

    const Enum = require("shared/util/Enum");

    const values = {
        OVERLAY: {
            value: "overlay",
            name: "Overlay"
        },
        SCENE: {
            value: "scene",
            name: "Scene"
        },
        BACKGROUND: {
            value: "background",
            name: "Background"
        }
    };

    const LayerEnum = Enum.create("LayerEnum", "value", values);

    return LayerEnum;
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/LayerEnum.js